import { render } from "./RecommendedCourses.vue?vue&type=template&id=444f3f9c&scoped=true"
import script from "./RecommendedCourses.vue?vue&type=script&lang=js"
export * from "./RecommendedCourses.vue?vue&type=script&lang=js"

import "./RecommendedCourses.vue?vue&type=style&index=0&id=444f3f9c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-444f3f9c"

export default script